import { h, t, T, domWithScope } from '@jsx6/jsx6'

export const areaDevicesError = (chat) => {
    return (
        <div p="area.DevicesError" hidden>
            <div class="alert-modal-wrapper">
                <div class="alert-modal-content">
                    <div p="deviceErrorMsg"></div>
                    <button class="btn btn-primary" p="deviceErrorBtn">OK</button>
                </div>
            </div>
        </div>
    )
}
